import React, { FunctionComponent } from 'react'

import { AUCTION_TYPES } from '../../../common/auctionScrapeTypes'
import { useAuctionMonitoringTabQuery } from '../../../graphql/generated'
import { useAppSelector } from '../../../redux/hooks'
import { useAuctionLabelIds } from '../../utils/useAuctionLabelIds'
import { useAuctionMonitoringFilter } from '../../utils/useAuctionMonitoringFilter'
import { AuctionMonitoringContent } from '../AuctionMonitoringContent/AuctionMonitoringContent'
import { AuctionMonitoringFilter } from '../AuctionMonitoringFilter/AuctionMonitoringFilter'
import { PageLayoutTabContainer } from '../PageLayoutTabContainer/PageLayoutTabContainer'

export interface AuctionMonitoringTabProps {
  auctionType: AUCTION_TYPES
}

export const AuctionMonitoringTab: FunctionComponent<AuctionMonitoringTabProps> =
  props => {
    const accountId = useAppSelector(state => state.myProfile.tenantId)
    const accountUserId = useAppSelector(state => state.myProfile.userId)

    const { data: labelIds } = useAuctionLabelIds()
    const { filterQuery, filter, handleChange } = useAuctionMonitoringFilter(
      props.auctionType
    )

    const [dataSource] = useAuctionMonitoringTabQuery({
      variables: {
        accountId,
        accountUserId,
        filter: filterQuery,
        labelIds: labelIds,
      },
    })

    return (
      <PageLayoutTabContainer className="flex-nowrap">
        <AuctionMonitoringFilter filter={filter} handleChange={handleChange} />
        <AuctionMonitoringContent
          filterQuery={filterQuery}
          filter={filter}
          dataSource={dataSource}
        />
      </PageLayoutTabContainer>
    )
  }
